import { TextFieldProps } from '@boltenergy-be/design-system'

export type EanProps = Pick<TextFieldProps<'number'>, 'onChange'> & {
  errorMessage?: string
  message?: string
  type: EanType
}

export type FieldNameAndParent = {
  parent: 'electricity' | 'gas'
  fieldName: 'ean' | 'eanExclNight'
}

// The values represent the dotted path to the field in the store
export enum EanType {
  ELECTRICITY = 'electricity',
  EXCL_NIGHT = 'exclNight',
  GAS = 'gas'
}
